// colorUtils.ts
export function generateShade(
  baseColor: string,
  shade: 'ok' | 'gap' | 'invalid',
): string {
  // Convert hex to HSL
  const hexToHSL = (H: string) => {
    // Convert hex to RGB first
    let r = 0,
      g = 0,
      b = 0;
    if (H.length === 4) {
      r = parseInt(H[1] + H[1], 16);
      g = parseInt(H[2] + H[2], 16);
      b = parseInt(H[3] + H[3], 16);
    } else if (H.length === 7) {
      r = parseInt(H.slice(1, 3), 16);
      g = parseInt(H.slice(3, 5), 16);
      b = parseInt(H.slice(5, 7), 16);
    }
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h = 0,
      s = 0;

    if (max !== min) {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return { h: h * 360, s: s * 100, l: l * 100 };
  };

  // Adjust lightness based on the state
  const hsl = hexToHSL(baseColor);
  let newL = hsl.l;
  switch (shade) {
    case 'ok':
      newL = Math.min(hsl.l + 10, 100); // Lighter
      break;
    case 'gap':
      newL = hsl.l; // Base
      break;
    case 'invalid':
      newL = Math.max(hsl.l - 10, 0); // Darker
      break;
  }

  return `hsla(${hsl.h}, ${hsl.s}%, ${newL}%, 0.6)`; // 0.6 alpha for transparency
}
